<template lang="pug">
  .page
    section
      b-container
        h1 TRANSACTION SUCCESSFUL
        h4 Your order has been submitted
        p Progress and shipping updates can be viewed under your profile
        b-button.btn-outline(:to="{name: 'AccountOrders'}") VIEW ORDER

</template>

<script>

export default {
  name: 'OrderOk',
  components: {
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/OrderOk.vue